import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import SiNoOptions from '../../support/catalogos/SiNoOptions'
import ComplementoInteresesHipotecariosRules from '../../support/rules/complementos/ComplementoInteresesHipotecariosRules'

const rules = ComplementoInteresesHipotecariosRules;

const ComplementoInteresesHipotecarios = (props) => {
  const [data, setData] = useState(props.data || {});
  const [validation, setValidation] = useState({
    validator: new Validator({}, rules),
    isValid: false,
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event,
    };

    setData(newData);
  };

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => validate(data), [data]);

  const handleOnAddComplemento = () => {
    const Intereseshipotecarios = {
      Version: '1.0',
      CreditoDeInstFinanc: data.CreditoDeInstFinanc,
      SaldoInsoluto: data.SaldoInsoluto,
      PropDeducDelCredit: data.PropDeducDelCredit,
      MontTotIntNominalesDev: data.MontTotIntNominalesDev,
      MontTotIntNominalesDevYPag: data.MontTotIntNominalesDevYPag,
      MontTotIntRealPagDeduc: data.MontTotIntRealPagDeduc,
      NumContrato: data.NumContrato,
    };

    props.onChange({ Intereseshipotecarios });

    clear();
  };

  const clear = () => {
    setData({});
  };

  const handleOnCancel = () => {
    props.onChange({ Intereseshipotecarios: undefined });
  };

  return (
    <div className="pb-4">
      <div>
          <strong className="text-black text-upper">Intereses Hipotecarios</strong>
      </div>

      <div className="section">
        <Form autoComplete="off">
          <Row>
            <Col sm md={4}>
              <FormControl
                type="select"
                label="Crédito otorgado por institución financiera"
                name="CreditoDeInstFinanc"
                placeholder=""
                help=""
                rules={rules.CreditoDeInstFinanc}
                value={data.CreditoDeInstFinanc}
                options={SiNoOptions}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Saldo insoluto"
                name="SaldoInsoluto"
                placeholder=""
                help=""
                rules={rules.SaldoInsoluto}
                value={data.SaldoInsoluto}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Proporción deducible del crédito"
                name="PropDeducDelCredit"
                placeholder=""
                help=""
                rules={rules.PropDeducDelCredit}
                value={data.PropDeducDelCredit}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Monto total intereses nominales devengados"
                name="MontTotIntNominalesDev"
                placeholder=""
                help=""
                rules={rules.MontTotIntNominalesDev}
                value={data.MontTotIntNominalesDev}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Monto total intereses nominales devengados y pagados"
                name="MontTotIntNominalesDevYPag"
                placeholder=""
                help=""
                rules={rules.MontTotIntNominalesDevYPag}
                value={data.MontTotIntNominalesDevYPag}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Monto total intereses reales pagados deducibles"
                name="MontTotIntRealPagDeduc"
                placeholder=""
                help=""
                rules={rules.MontTotIntRealPagDeduc}
                value={data.MontTotIntRealPagDeduc}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Número de contrato del crédito hipotecario"
                name="NumContrato"
                placeholder=""
                help=""
                rules={rules.NumContrato}
                value={data.NumContrato}
                onChange={handleOnChange}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                variant="secondary"
                className="mr-2"
                onClick={handleOnCancel}
              >
                Cancelar
              </Button>

              <Button
                variant="primary"
                disabled={!isValid}
                onClick={handleOnAddComplemento}
              >
                Agregar complemento
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ComplementoInteresesHipotecarios;
